/*
 * File: EditProviderOfficeFee.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Form for editing providers, office, and fee schedule for a patient
 */
import React from "react";
import FormBuilder from "components/form-builder";
import UIProgress from "components/ui/UIProgress";
import PatientIdStore from "services/patients/store/PatientIdStore";
import References from "services/references/References";
import Users from "services/users/Users";
import ProviderOfficeFeeFormModel from "../store/ProviderOfficeFeeFormModel";
import { clone } from "mobx-state-tree";
import FormStore from "components/form-builder/FormStore";
import PropTypes from "prop-types";
import { StoreContext } from "utils/useStore";

class EditProviderOfficeFee extends React.Component {
  static contextType = StoreContext;

  state = {
    loading: true
  };

  static contextType = StoreContext;

  constructor(props) {
    super(props);
    this.editingChargeModelCopy = clone(props.providerOfficeFeeModel);
    this.formStore = FormStore.create();
  }

  componentDidMount() {
    this.populateSelectFields();
    this.formStore.setFields(ProviderOfficeFeeFormModel);
  }

  async populateSelectFields() {
    const references = this.context.getStore(References);
    const offices = await references.forSelect("offices");
    const feeSchedules = await references.forSelect("feeSchedules");
    const providers = await this.context.getStore(Users).forSelect("providers");

    this.setFormOptions("patientOffice", offices);
    this.setFormOptions("feeSchedule", feeSchedules);
    this.setFormOptions("patientProvider", providers);
    this.setFormOptions("accountProvider", providers);

    this.setState({
      loading: false
    });
  }

  setFormOptions(key, val) {
    let fieldModel = this.formStore.getFieldByName(key);
    fieldModel.setFormOptions(val);
  }

  onChange = (key, val) => {
    this.editingChargeModelCopy.update(key, val);
  };

  onSubmit = async () => {
    let patientId = PatientIdStore.getId();
    await this.editingChargeModelCopy.updateProviderOfficeFee(patientId);
    await this.editingChargeModelCopy.getProviderOfficeFeeData();
    this.props.parentCallBack(this.editingChargeModelCopy);
  };

  onCancel = async () => {
    this.props.parentCallBack();
  };

  render() {
    let { loading } = this.state;
    return (
      <div>
        {loading && <UIProgress />}
        {!loading && (
          <FormBuilder
            formStore={this.formStore}
            data={this.editingChargeModelCopy}
            parentOnChange={this.onChange}
            parentOnSubmit={this.onSubmit}
            parentOnCancel={this.onCancel}
          />
        )}
      </div>
    );
  }
}

EditProviderOfficeFee.propTypes = {
  providerOfficeFeeModel: PropTypes.object.isRequired,
  parentCallBack: PropTypes.func.isRequired
};

export default EditProviderOfficeFee;
